import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmfspain() {
  return (
    <>
        <Helmet>
            <title>GMF Spain | Gandhi Mandela Foundation</title>
            <meta name="description" content="GMF Spain" />
            <link rel="canonical" href="/gmfspain" />
        </Helmet>
      <Header />
        <div>
            <section className="page-header">
                <div className="container">
                <div className="breadcrumb">
                    <a href="/">Home</a>
                    <span>/</span>
                    <span>GMF Spain</span>
                </div>
                <h1>GMF Spain</h1>
                </div>
            </section>
            {/* =========================
                BOARD MEMBERS
            ========================= */}
            <section className="board-members">
                <div className="container">
                <div className="members-grid">
                    <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Jose-Raul-Vaquero-Pulido.jpg" alt="Jose-Raul-Vaquero-Pulido" />
                    </div>
                    <h3>Jose-Raul-Vaquero-Pulido</h3>
                    <span>(President, Spain)</span>
                    </div>
                    <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/Maria-Auxiliadora-Martin.jpg" alt="Maria Auxiliadora Martin" />
                    </div>
                    <h3>Maria Auxiliadora Martin</h3>
                    <span>(Vice President for Leadership and Empowerment of Women)</span>
                    </div>
                    <div className="member-card">
                    <div className="member-img">
                        <img src="img/members/ignacio-bonasa.jpg" alt="Ignacio Bonasa" />
                    </div>
                    <h3>Ignacio Bonasa</h3>
                    <span>(Vice President for Humanistic Leadership, Art, and Social Welfare )</span>
                    </div>
                </div>
                </div>
            </section>
            </div>

      <Footer />
    </>
  )
}
